var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"iframe",class:{full:_vm.fullscreen},attrs:{"id":"ifr","height":_vm.minIframeHeight,"src":_vm.src,"frameborder":"0"},on:{"load":_vm.onIframeLoad}})}
var staticRenderFns = []

export { render, staticRenderFns }